'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import ModalBody from "../Modal/ModalBody.js";
var DrawerBody = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ModalBody, _extends({
    classPrefix: "drawer-body"
  }, props, {
    ref: ref
  }));
});
export default DrawerBody;